import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MSIcon from '@/assets/icons/ms-icon.svg?react';
import TopNav from '@/components/layout/top-nav';
import { Button } from '@/components/ui/button';
import useAuth from '@/hooks/use-auth';
import useSignIn from '@/hooks/use-sign-in';
import { APP_ROUTES } from '@/lib/routes/app-routes';

const SignInPage = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { mutate: signInUser, isPending, isSuccess } = useSignIn();

  const isSigningIn = isPending || isSuccess;

  useEffect(() => {
    if (isAuthenticated) {
      navigate(APP_ROUTES.dashboard);
    }
  }, [isAuthenticated, navigate]);

  const handleSignIn = () => {
    signInUser();
  };

  return (
    <div className="bg-background flex min-h-screen flex-col">
      <TopNav visibility={false} />
      <div className="flex flex-1 items-center justify-center">
        <div className="flex flex-col items-center gap-6">
          <p className="text-foreground text-center text-xl font-semibold">
            {t('common:signIn.title')}
          </p>
          <p className="text-muted-foreground text-center text-sm">{t('common:signIn.subtitle')}</p>
          <Button
            onClick={handleSignIn}
            disabled={isSigningIn}
            className="bg-background border-border text-foreground hover:bg-muted flex h-10 w-54.5 items-center justify-center gap-2 rounded-lg border px-5 py-2 shadow-sm"
          >
            <MSIcon className="size-6" />
            <span className="text-md">{t('common:signIn.button')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
